import { defineStore } from 'pinia'

type TCommonStoreState = {
  rehearsalTipFlagMap: Record<string, boolean>
}

export const useCommonStore = defineStore('commonStore', {
  state: (): TCommonStoreState => {
    return {
      rehearsalTipFlagMap: {}, // 包裹预演提示状态
    }
  },

  //同步异步都可以
  actions: {
    setRehearsalTipFlag(key: string) {
      this.rehearsalTipFlagMap[key] = true
    },
  },
  persist: {
    key: '_common_store_',
    storage: localStorage,
    paths: ['rehearsalTipFlagMap'],
  },
})
